module.exports = __webpack_public_path__ + "static/sport/swiper-1.913577d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/swiper-1.png
// module id = 5Q1I
// module chunks = 0